import TabPage from "./../../factories/tab-page";
import "./../../factories/tab-controller";
import "./../../bindings/bao-tabs";
import "./../../bindings/bao-searcher";
import "./../../bindings/bao-date-time-box";
import "./../../bindings/bao-date-time-picker";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import SubscriptionViewModel from "./../../factories/subscription-view-model";
import baoRouter from "./../../services/bao-router";
import BaoDialog from "./../../factories/bao-dialog";
import BaoMenu from "./../../services/bao-menu";
import finitoService from "./../../services/finito-service";
import TabController from "./../../factories/tab-controller";
class BypassReportModel {
    Bao = Bao;
    TabPage: TabPage;
    PageSize = ko.observable(10);
    TotalRows = ko.observable(0);
    PageIndex = ko.observable(0);
    Sorting = ko.observableArray();
    Columns = ko.observableArray([]);
    Fields = ko.observableArray([]);
    EvaluationCollection = ko.observableArray([]);
    StartDateTime = ko.observable('');
    EndDateTime = ko.observable('');
    ReportLoaded = ko.observable(false);
    Parent;
    ShiftbookId = ko.observable('');
    Name = ko.observable('');
    ChecklistId = ko.observable('');
    ChecklistName = ko.observable('');
    IsReportResultEmpty = ko.pureComputed(() => {
        return Boolean(this.ReportLoaded() && typeof this.EvaluationCollection() !== "undefined" && this.EvaluationCollection().length === 0);
    });
    SearcherShiftbook: Bindings.baoSearcher = {
        ObjectId: this.ShiftbookId,
        ObjectValue: 'Name',
        SearchType: 'Shiftbook',
        AutoComplete: true,
        AutoSearch: true,
        CustomFilter: { ShiftbookTypeId: '1AB743AA-C33C-4DB9-8920-3C8E79B501E3' }
    };
    //TODO custom filter (filtering by category id)
    SearcherChecklist: Bindings.baoSearcher = {
        ObjectId: this.ChecklistId,
        ObjectValue: 'ListName1',
        SearchType: 'Checkware-Checklist',
        AutoComplete: true,
        AutoSearch: true,
    };
    constructor(parent: any) {
        this.Parent = parent;
        this.TabPage = parent.TabPage;
    }
    init() {
    }
    loaded() {
        this.TabPage.IsLoading(false);
    }
    Display = () => {
        if (!this.IsComplete()) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
            return;
        }
        if (!this.IsValidDateFields()) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("DateTimeFieldsAreInvalid"), "info");
            return;
        }
        this.TabPage.IsLoading(true);
        this.getDataFromServer(true).then(data => {
            this.EvaluationCollection(data.Evaluations);
            this.Columns(data.Columns);
            this.TotalRows(data.TotalRows);
            this.Fields(data.Fields);
            this.TabPage.IsLoading(false);
            this.ReportLoaded(true);
            this.TabPage.IsLoading(false);
        }).fail(() => {
            this.ReportLoaded(false);
            this.TabPage.IsLoading(false);
        });
    };
    /** check if the manditory form fields are filled
     */
    IsComplete() {
        return Boolean(!Bao.Utils.String.IsNullOrEmpty(this.StartDateTime()) && !Bao.Utils.String.IsNullOrEmpty(this.EndDateTime()));
    }
    ;
    IsValidDateFields = () => {
        return Boolean(Bao.Utils.String.IsNullOrEmpty(this.StartDateTime()) || Bao.Utils.String.IsNullOrEmpty(this.EndDateTime()) ||
            (Number(this.EndDateTime()) >= Number(this.StartDateTime())));
    };
    private getDataFromServer(saveFilter) {
        return Bao.post("ReportCenter/BypassShiftbookGetReportModel", JSON.stringify({
            startDate: this.StartDateTime(),
            endDate: this.EndDateTime(),
            pageIndex: this.PageIndex(),
            pageSize: this.PageSize(),
            shiftbookId: this.ShiftbookId(),
            checklistId: this.ChecklistId()
        }));
    }
}
export default BypassReportModel;